import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export const sfWebToLead = window.lt.api.sfWebToLead as ltFramework.IDictionary;
